import { MODEL_DASHBOARD_DEFAULT_NEW_SECTION_NAME } from '@mpm-druid/constants';
import randomstring from 'randomstring';
import { IDashboardSection } from './DashboardSection';

export function getSectionById<SectionItem>(
  sections: IDashboardSection<SectionItem>[],
  id: string
): IDashboardSection<SectionItem> {
  return sections.find(section => section.id === id) || generateEmptySection();
}

export function generateEmptySection<SectionItem>(
  title = MODEL_DASHBOARD_DEFAULT_NEW_SECTION_NAME
): IDashboardSection<SectionItem> {
  return {
    id: randomstring.generate(6),
    isExpanded: true,
    items: [],
    layout: [],
    title
  };
}
